// Shared by useWorkflows and useAvailableWorkflows: Organization-owned event types
// resolve workflows against the creator user, not the org.
export const getWorkflowsOwner = ({ ownerType, ownerId, creatorId }) => {
  if (ownerType === 'Organization') {
    return { id: creatorId, type: 'user' }
  }
  return { id: ownerId, type: ownerType }
}
